<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="30"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Services</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2">
                    <div class="mb-1">Nuværende valg:</div>
                    <div v-if="booking.booking_services.length > 0">
                        <div v-for="service in booking.booking_services">
                           <input type="checkbox" disabled checked>
                            <label class="ml-2 mb-0">
                                {{ service.service ? service.service.name : '' }}
                            </label>
                        </div>
                    </div>
                    <div v-else-if="booking.product">
                        <input type="checkbox" disabled checked>
                        <label class="ml-2 mb-0">
                            {{ booking.product.description }}
                        </label>
                    </div>
                </div>
                <br>
                <div class="mb-2">
                    <div class="mb-1">Se mulige tilvalg:</div>
                    <div class="d-flex mb-1" v-if="additionalServices[additionalServiceCallFromDriver]">
                        <input type="checkbox"
                               :id="`additional-${additionalServiceCallFromDriver}`"
                               v-model="additionalServices[additionalServiceCallFromDriver].enabled"
                        >
                        <label class="ml-2 mb-0" :for="`additional-${additionalServiceCallFromDriver}`">
                            {{ additionalServices[additionalServiceCallFromDriver].name }}
                            ({{ additionalServices[additionalServiceCallFromDriver].price }} kr.)
                        </label>
                    </div>
                    <div v-for="(item, key) in additionalServices"
                         v-if="[additionalServiceShorterTimeInterval].includes(key)"
                    >
                        <div class="d-flex mb-1">
                            <input type="checkbox"
                                   :id="`additional-${key}`"
                                   v-model="item.enabled"
                            >
                            <label class="ml-2 mb-0" :for="`additional-${key}`">
                                {{ item.name }}
                            </label>
                        </div>
                        <div v-if="key === additionalServiceShorterTimeInterval && item.enabled"
                             class="mb-2"
                        >
                            <div class="align-items-center bg-white rounded-lg div-focus">
                                <select v-model="additionalServices[key].value"
                                        class="form-control"
                                        @change="onChangeShorterTimeInterval">
                                    <option value=""></option>
                                    <option v-for="interval in shorterTimeIntervals"
                                            :value="interval"
                                    >
                                        {{ interval.when }} {{ interval.time }} ({{ interval.price }} kr.)
                                    </option>
                                </select>
                            </div>
                            <div class="text-danger" v-if="errors[additionalServiceShorterTimeInterval]">
                                {{ errors[additionalServiceShorterTimeInterval] }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-1" v-if="additionalServices[additionalServiceInsurance]">
                        <input type="checkbox"
                               :id="`additional-${additionalServiceInsurance}`"
                               v-model="additionalServices[additionalServiceInsurance].enabled"
                        >
                        <label class="ml-2 mb-0" :for="`additional-${additionalServiceInsurance}`">
                            {{ additionalServices[additionalServiceInsurance].name }}
                            ({{ additionalServices[additionalServiceInsurance].price }} kr.)
                        </label>
                    </div>
                    <div v-if="availableServices.length" class="mt-3">
                        <div v-for="(service, i) in availableServices" class="d-flex">
                            <input type="checkbox"
                                   :value="service['id']"
                                   :id="`prime-${service['id']}`"
                                   v-model="availableServices[i].enabled"
                                   @change="onChangePrimeService(service)"
                            />
                            <label class="ml-2 mb-0" :for="`prime-${service['id']}`">
                                {{ service.name }} ({{ service.price }} kr.)
                            </label>
                        </div>
                    </div>
                </div>
                <br>
                <div>
                    <button class="btn btn-success" @click="goNext">Næste STEP</button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            Din levering vil blive opgraderet til en STEP PRIME levering.
                            Da din levering nu vil kræve 2 knivskarpe chauffører, betyder det at din leveringsdag rykkes.
                            Du adviseres altid med leveringsdatoen 2 dage i forvejen, samt et 4-timers interval for leveringen dagen før.
                            Forbered dig bedst muligt på din levering via vores kundeguide.
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary mb-1" data-dismiss="modal" @click="toggleModal">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <modal-iframe ref="modal-iframe"
                      @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeModalInterval || activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "./reusable/ProgressBar.vue";
import BackSection from "./reusable/BackSection.vue";
import ModalIframe from "./reusable/ModalIframe.vue";
import FlashError from "./reusable/FlashError.vue";
import priceMixin from "../../mixins/priceMixin";
import dateTimeMixin from "../../mixins/dateTimeMixin";
import moment from "moment";
export default {
    name: "CmfStep2",
    components: {FlashError, ProgressBar, BackSection, ModalIframe},
    mixins: [priceMixin, dateTimeMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        insuranceProp: {type: Object, required: false},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServiceShorterTimeInterval: {type: String, required: true},
        additionalServiceInsurance: {type: String, required: true},
        additionalServicePrime: {type: String, required: true},
        additionalServiceCallFromDriver: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        availableServicesProp: {type: Array, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
    },
    data() {
        return {
            activeIframeModalInterval: false,
            activeModalInterval: false,
            show: false,
            additionalServices: this.additionalServicesProp.length === undefined ? this.additionalServicesProp : {},
            availableServices: this.availableServicesProp,
            shorterTimeIntervals: {},
            insurance: this.insuranceProp,
            errors: {},
            isDeliveryDateValid: this.booking.dropoff_end &&
                !this.booking.dropoff_end.includes('-0001-11-30') &&
                !this.booking.dropoff_end.includes('0000-00-00')
        }
    },
    created() {
        if (this.configurations.call_from_driver && this.configurations.call_from_driver.value) {
            this.configurations.call_from_driver.value = JSON.parse(this.configurations.call_from_driver.value);
            if (!this.additionalServices[this.additionalServiceCallFromDriver] &&
                this.configurations.call_from_driver.value.enabled
            ) {
                this.$set(this.additionalServices, this.additionalServiceCallFromDriver, {
                    key: this.additionalServiceCallFromDriver,
                    name: 'Opkald fra chauffør inden levering',
                    value: 'Opkald fra chauffør inden levering',
                    price: this.calculatePriceWithVatAndRoundToNearestTens(this.configurations.call_from_driver.value.price),
                    enabled: false
                });
            }
        }

        if (this.configurations.shorter_time_intervals) {
            this.shorterTimeIntervals = JSON.parse(this.configurations.shorter_time_intervals.value);
            for (let i in this.shorterTimeIntervals) {
                if (this.shorterTimeIntervals[i].price > 0) {
                    this.$set(
                        this.shorterTimeIntervals[i],
                        'price',
                        this.calculatePriceWithVatAndRoundToNearestTens(this.shorterTimeIntervals[i].price)
                    );
                }
            }
        }

        for (let j in this.availableServices) {
            this.$set(
                this.availableServices[j],
                'price',
                this.calculatePriceWithVatAndRoundToNearestTens(this.availableServices[j].price)
            );
        }

        if (!this.additionalServices[this.additionalServiceInsurance] && this.insurance) {
            this.$set(this.additionalServices, this.additionalServiceInsurance, {
                key: this.additionalServiceInsurance,
                name: 'Forsikring af din levering',
                value: this.insurance.id,
                price: 0,
                enabled: false
            });

            let price = '';
            let intervalPrice;
            for(let i in this.insurance.prices) {
                intervalPrice = this.insurance.prices[i];
                intervalPrice.price = parseFloat(intervalPrice.price);
                if (intervalPrice.interval.max_weight < this.booking.total_weight ||
                    intervalPrice.interval.max_volume < this.booking.total_volume
                ) {
                    continue;
                }

                if (price === '' || price > intervalPrice.price) {
                    price = intervalPrice.price;
                    this.$set(
                        this.additionalServices[this.additionalServiceInsurance],
                        'price',
                        this.calculatePriceWithVatAndRoundToNearestTens(price)
                    );
                }
            }
        }

        if (!this.additionalServices[this.additionalServiceShorterTimeInterval]) {
            this.$set(this.additionalServices, this.additionalServiceShorterTimeInterval, {
                key: this.additionalServiceShorterTimeInterval,
                name: 'Kortere tidsinterval',
                value: '',
                price: 0,
                enabled: false
            });
        }

        if(!this.additionalServices[this.additionalServicePrime] &&
            !this.booking['primeServicesWasSelected']
        ) {
            this.$set(this.additionalServices, this.additionalServicePrime, {key: this.additionalServicePrime});

        } else if(this.additionalServices[this.additionalServicePrime]) {
            for (let i in this.availableServices) {
                if (this.additionalServices[this.additionalServicePrime][this.availableServices[i]['id']] &&
                    this.additionalServices[this.additionalServicePrime][this.availableServices[i]['id']].enabled
                ) {
                    this.$set(this.availableServices[i], 'enabled', true);
                }
            }
        }

        // Check shorter_time_interval_cut_off_time
        // https://app.asana.com/0/1201636296551651/1207809971532795
        if (this.configurations.shorter_time_interval_cut_off_time &&
            this.configurations.shorter_time_interval_cut_off_time.value &&
            this.booking.dropoff_end
        ) {
            this.$set(
                this.configurations.shorter_time_interval_cut_off_time,
                'value',
                JSON.parse(this.configurations.shorter_time_interval_cut_off_time.value)
            );

            if (this.configurations.shorter_time_interval_cut_off_time.value.enabled &&
                this.configurations.shorter_time_interval_cut_off_time.value.day &&
                this.configurations.shorter_time_interval_cut_off_time.value.time
            ) {
                let dropoffDate = moment(this.booking.dropoff_end);
                let cutOffDay = this.configurations.shorter_time_interval_cut_off_time.value.day;
                let time = this.configurations.shorter_time_interval_cut_off_time.value.time.split(':');
                if (cutOffDay === this.today) {
                    cutOffDay = moment();
                } else if (cutOffDay === this.tomorrow) {
                    cutOffDay = moment().add(1, 'days');
                } else {
                    cutOffDay = moment().add(2, 'days');
                }
                cutOffDay.hours(time[0]);
                cutOffDay.minutes(time[1]);
                cutOffDay.seconds(0);
                console.log(cutOffDay);
                console.log(dropoffDate);
                if (cutOffDay.isAfter(dropoffDate)) {
                    this.$delete(this.additionalServices, this.additionalServiceShorterTimeInterval);
                }
            }
        }
        // ************
    },
    methods: {
        validate() {
            this.errors = {};

            let arr = [this.additionalServiceShorterTimeInterval];

            for (let i = 0; i < arr.length; i++) {
                if (this.additionalServices[arr[i]] &&
                    this.additionalServices[arr[i]].enabled &&
                    !this.additionalServices[arr[i]].value
                ) {
                    this.$set(this.errors, arr[i], 'The value can\'t be empty');
                }
            }
        },
        goNext() {
            this.validate();
            setTimeout(() => {
                if (!Object.keys(this.errors).length) {
                    axios.post(this.applyChangesUrl, this.additionalServices)
                        .then((response) => {
                            window.location.href = this.nextUrl;

                        }).catch(error => {
                        this.$refs.flashError.flashError(error);
                    });
                }
            }, 50);

        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        onChangeShorterTimeInterval() {
            setTimeout(() => {
                if (this.additionalServices[this.additionalServiceShorterTimeInterval]['value']) {
                    for (let i in this.shorterTimeIntervals) {
                        if (this.additionalServices[this.additionalServiceShorterTimeInterval]['value']['when'] ===
                            this.shorterTimeIntervals[i]['when'] &&
                            this.additionalServices[this.additionalServiceShorterTimeInterval]['value']['time'] ===
                            this.shorterTimeIntervals[i]['time']
                        ) {
                            this.$set(this.additionalServices[this.additionalServiceShorterTimeInterval],
                                'price',
                                this.shorterTimeIntervals[i]['price']
                            );
                        }
                    }
                } else {
                    this.$set(this.additionalServices[this.additionalServiceShorterTimeInterval], 'price', 0);
                }

            }, 500);
        },
        onChangePrimeService(service) {
            this.$set(this.additionalServices[this.additionalServicePrime], service['id'], {
                name: service.name,
                price: service.price,
                enabled: service.enabled
            });

            if (this.isDeliveryDateValid && service.enabled) {
                this.toggleModal();
            }
        }
    },
}

</script>

<style scoped>

</style>
